import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const skinPlugin = createPluginFromSingleComponentPlugin({
    name: 'SkinPlugin',
    pack,
    unpack
})
